/**
 * APPLICATION:THEG_MOVIES_LIBRARY bottom navigation.
 * Consumes THEG_MOVIES_LIBRARY_BOTTOM_NAV only. No enterprise Control Tower tabs.
 * Host SPA mount: uses History API + <a href> (Vite client) — not next/link.
 * AGENT:GROK_BOT — HOST_SPA_MOUNT 2026-10-01
 */
"use client";

import { useEffect, useState } from "react";
import {
  THEG_MOVIES_LIBRARY_BOTTOM_NAV,
  assertThegFiveTabs,
} from "./theg-movies-library-nav-registry";

assertThegFiveTabs();

function readPathname(): string {
  if (typeof window === "undefined") return "";
  return window.location.pathname || "";
}

export function ThegMoviesBottomNav() {
  const [pathname, setPathname] = useState(readPathname);

  useEffect(() => {
    const sync = () => setPathname(readPathname());
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  return (
    <nav
      aria-label="THEG Movies Library primary"
      className="fixed inset-x-0 bottom-0 z-40 grid h-14 grid-cols-5 border-t border-border/40 bg-background/95 backdrop-blur"
      data-theg-nav="HOME|MOVIES|SEARCH|CHATGPT|JOBS"
    >
      {THEG_MOVIES_LIBRARY_BOTTOM_NAV.map((tab) => {
        const active = pathname === tab.route || pathname.startsWith(`${tab.route}/`);
        return (
          <a
            key={tab.id}
            href={tab.route}
            aria-current={active ? "page" : undefined}
            className={`flex flex-col items-center justify-center text-[10px] font-semibold tracking-wide ${
              active ? "text-primary" : "text-foreground/55"
            }`}
            onClick={(event) => {
              if (
                event.defaultPrevented ||
                event.button !== 0 ||
                event.metaKey ||
                event.altKey ||
                event.ctrlKey ||
                event.shiftKey
              ) {
                return;
              }
              event.preventDefault();
              if (window.location.pathname === tab.route) return;
              window.history.pushState({}, "", tab.route);
              window.dispatchEvent(new PopStateEvent("popstate"));
              setPathname(tab.route);
            }}
          >
            <span>{tab.mobileLabel}</span>
          </a>
        );
      })}
    </nav>
  );
}
